import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme)=>({
	clickable:{
		color: theme.overrides.MuiButton.outlinedPrimary.color,
		cursor:'pointer',
		fontWeight:'bolder',
	},
	text:{
		fontSize: 16,
		color: theme.palette.colors.gray,
		lineHeight: 1.4,
		fontWeight: 'normal',
	}
}));

export default useStyles;
